<template>
    <div
        v-if="status === 'WARNING' || status === 'ERROR'"
        class="cell-validate-label"
        :class="status"
    >
        <i v-if="status === 'WARNING'" class="el-icon-warning"></i>
        <i v-if="status === 'ERROR'" class="el-icon-error"></i>
        <span> {{ msg }}</span>
    </div>
</template>
<script>
export default {
    props: {
        status: {
            type: String,
            default: 'NONE',
        },
        msg: {
            type: String,
            default: '',
        },
    },
    data() {
        return {};
    },
};
</script>
<style lang="scss">
.cell-validate-label {
    font-size: 8pt;
    &.WARNING {
        color: orange;
    }
    &.ERROR {
        color: red;
    }
}
</style>
